var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n  Uuuuupsi: Das hätte nicht passieren dürfen. Anscheinend haben Sie einen veralteten Link gefunden. Nutzen Sie die Navigation oben, um zurück zur Hauptseite zu gelangen.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }